import { UF_SYSTEM_LOAD, CONTACT_DETRAN_LIST_LOAD, CONTACT_DETRAN_LIST_UNLOAD } from "../../actions/Constants";

const INITIAL_STATE = { ufSystem: [], contacts: [] };

export default function contatosDetran(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UF_SYSTEM_LOAD:
      return {
        ...state,
        ufSystem: action.payload ? action.payload : [],
      };
    case CONTACT_DETRAN_LIST_LOAD:
      return {
        ...state,
        contacts: action.payload ? action.payload : [],
      };
    case CONTACT_DETRAN_LIST_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
